import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import ClockIcon from "../img/Clock.svg";
import ColoredIcon from "./ColoredIcon";

interface Props {
    time: number; // in minutes
    size?: "big" | "small";
    textColor?: "black" | "white" | "brand";
}

const FormattedTime = ({
    time,
    size = "small",
    textColor = "black",
}: Props) => {
    const theme = useTheme();

    const hours = Math.floor(time / 60);
    const mins = Math.floor(time % 60);

    const color =
        textColor === "brand" ? theme.palette.primary.main : textColor;

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={size === "big" ? 0.5 : 0.25}
        >
            <ColoredIcon
                icon={ClockIcon}
                color={color}
                size="16px"
                style={{ opacity: "50%" }}
            />
            <Typography
                fontSize="15px"
                lineHeight="22px"
                color={color}
                sx={{ whiteSpace: "nowrap" }}
            >
                {hours > 0
                    ? `${hours}\u00A0${mins === 0 ? "hours" : "h"} `
                    : ""}
                {mins > 0
                    ? `${mins}\u00A0${hours === 0 ? "minutes" : "min"}`
                    : ""}
            </Typography>
        </Stack>
    );
};

export default FormattedTime;
